import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FiArrowLeft,
  FiPlus,
  FiGrid,
  FiMessageSquare,
  FiPhoneCall,
  FiMail,
} from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { MdChatBubbleOutline } from "react-icons/md";
import { TemplateDataTable } from "./TemplateDataTable";
import SmsTemplate from "./SmsTemplateNew";
import VoiceTemplate from "./VoiceTemplateNew";
import EmailTemplate from "./EmailTemplateNew";
import WhatsappTemplate from "./WhatsappTemplateNew";
import RcsTemplate from "./RcsTemplateNew";
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import styles from "./TemplateView.module.css";

const CHANNEL_TABS = [
  // { key: "ALL", label: "All", icon: FiGrid },
  { key: "SMS", label: "SMS", icon: FiMessageSquare },
  { key: "WHATSAPP", label: "WhatsApp", icon: FaWhatsapp },
  { key: "RCS", label: "RCS", icon: MdChatBubbleOutline },
  { key: "VOICE", label: "Voice", icon: FiPhoneCall },
  { key: "EMAIL", label: "Email", icon: FiMail },
];


const ALL_DATA = [
  {
    id: "1",
    name: "Winter_Sale_2025",
    updated: "2025-12-04",
    channel: "WHATSAPP",
    volume: 12500,
    engagement: 85,
    status: "approved",
  },
  {
    id: "2",
    name: "OTP_Verification_V2",
    updated: "2025-11-20",
    channel: "SMS",
    volume: 89000,
    engagement: 92,
    status: "approved",
  },
  {
    id: "3",
    name: "Appt_Reminder_Clinic",
    updated: "2025-12-05",
    channel: "WHATSAPP",
    volume: 0,
    engagement: 0,
    status: "pending",
  },
  {
    id: "4",
    name: "Rich_Card_Promo",
    updated: "2025-12-01",
    channel: "RCS",
    volume: 0,
    engagement: 0,
    status: "rejected",
  },
];

const fetchTemplates = async ({
  page,
  limit,
  search,
  sort,
  filters,
}) => {
  let data = [...ALL_DATA];

  if (filters?.channel && filters.channel !== "ALL") {
    data = data.filter((r) => r.channel === filters.channel);
  }

  if (search) {
    const q = search.toLowerCase();
    data = data.filter((r) =>
      r.name.toLowerCase().includes(q)
    );
  }

  if (sort.key) {
    data.sort((a, b) => {
      if (a[sort.key] < b[sort.key])
        return sort.order === "asc" ? -1 : 1;
      if (a[sort.key] > b[sort.key])
        return sort.order === "asc" ? 1 : -1;
      return 0;
    });
  }

  const start = (page - 1) * limit;

  return {
    data: data.slice(start, start + limit),
    total: data.length,
  };
};

const VALID_KEYS = ["SMS", "WHATSAPP", "RCS", "VOICE", "EMAIL"];

const TemplateView = () => {
  const { search } = useLocation();
  const channelParam = new URLSearchParams(search).get("channel")?.toUpperCase();
  const [activeTab, setActiveTab] = useState(
    VALID_KEYS.includes(channelParam) ? channelParam : "SMS"
  );

  const columns = [
    {
      key: "name",
      label: "Name",
      render: (row) => (
        <div>
          <div className={styles.name}>{row.name}</div>
          <div className={styles.updated}>
            Updated: {row.updated}
          </div>
        </div>
      ),
    },
    {
      key: "channel",
      label: "Channel",
      sortable: true,
      render: (row) => (
        <span
          className={`${styles.channel} ${
            styles[row.channel.toLowerCase()]
          }`}
        >
          {row.channel}
        </span>
      ),
    },
    {
      key: "volume",
      label: "Volume",
      sortable: true,
      render: (row) => row.volume.toLocaleString(),
    },
    {
      key: "engagement",
      label: "Engagement",
      sortable: true,
      render: (row) => (
        <div className={styles.engagement}>
          <span>{row.engagement}%</span>
          <div className={styles.progress}>
            <span style={{ width: `${row.engagement}%` }} />
          </div>
        </div>
      ),
    },
    {
      key: "status",
      label: "Status",
      sortable: true,
      render: (row) => (
        <span
          className={`${styles.status} ${
            styles[row.status]
          }`}
        >
          {row.status.toUpperCase()}
        </span>
      ),
    },
  ];

  return (
    <>
      {/* HEADER */}
      <DashboardLayout>
          <main className="content">
        <div className="container-fluid p-0">
      <div className={styles.header}>
        <div className={styles.title}>
          <Link
            to="/dashboard/template"
            className={styles.back}
          >
            <FiArrowLeft />
          </Link>
          Template List
        </div>

        <Link
          to="/dashboard/template-create"
          className={styles.createBtn}
        >
          <FiPlus />
          Create New Template
        </Link>
      </div>

      {/* CHANNEL SWITCH */}
      <div className={styles.tabs}>
        {CHANNEL_TABS.map(
          ({ key, label, icon: Icon }) => (
            <button
              key={key}
              className={`${styles.tab} ${
                activeTab === key
                  ? styles.active
                  : ""
              }`}
              onClick={() => setActiveTab(key)}
            >
              <Icon size={14} />
              <span>{label}</span>
            </button>
          )
        )}
      </div>

      {/* TABLE */}
      {/* <TemplateDataTable
        columns={columns}
        fetchData={fetchTemplates}
        pageSize={5}
        filters={{ channel: activeTab }}
        flags={{
          search: true,
          sorting: true,
          pagination: true,
          skeleton: true,
        }}
      /> */}
      {activeTab === "SMS" && <SmsTemplate />}
      {activeTab === "VOICE" && <VoiceTemplate/>}
      {activeTab === "EMAIL" && <EmailTemplate/>}
      {activeTab === "WHATSAPP" && <WhatsappTemplate/>}
      {activeTab === "RCS" && <RcsTemplate/>}

      </div>
      </main>
      </DashboardLayout>
    </>
  );
};

export default TemplateView;
